import { useState, useCallback, memo } from "react";
import { CheckCircle, CheckCircleOutline } from "@mui/icons-material";
import { ListItem, ListItemIcon, ListItemText, Switch, Box, Fade } from "@mui/material";
import { Task } from "../../../context/scope-of-work.types";
import { TaskNoteBubble } from "./TaskNoteBubble";
import { colors } from "../../../../../../../ui/colors";

//jobs switch
const COLORS = {
  orange: { base: colors.orange.base },
  gray: { 300: "#D1D5DB", 600: "#4B5563" },
};

interface TaskSwitchProps {
  task: Task;
  checked: boolean;
  disabled: boolean;
  quantity: number;
  onToggle: () => void;
  areaUid: string;
}

const TaskSwitchComponent = ({ task, checked, disabled, quantity, onToggle, areaUid }: TaskSwitchProps) => {
  const [hover, setHover] = useState(false);

  const handleToggle = useCallback(() => {
    if (disabled) return;
    onToggle?.();
  }, [disabled, onToggle]);

  const taskId = String((task as any).uid ?? (task as any).id);
  const noteFromStore = (task as any).note ?? "";
  const hasNote = noteFromStore.trim().length > 0;

  console.log("TASK:", task);
  return (
    <ListItem
      sx={{
        p: 1,
        "&:hover": { backgroundColor: "rgba(var(--fx-surface-textrgb, 15, 23, 42), 0.02)" },
        position: "relative",
      }}
      disableGutters
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
    >
      {quantity > 0 && checked && (hasNote || hover) && (
        <Fade in={hasNote || hover}>
          <Box
            sx={{
              position: "absolute",
              top: "50%",
              right: 36,
              transform: "translateY(-50%)",
              zIndex: 9999,
            }}
            onClick={(e) => e.stopPropagation()}
          >
            <TaskNoteBubble areaUid={areaUid} taskId={taskId} taskName={task.name} noteFromStore={noteFromStore} />
          </Box>
        </Fade>
      )}

      <ListItemText
        primaryTypographyProps={{
          variant: "body2",
          color: COLORS.gray[600],
        }}
        primary={<Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>{task.name}</Box>}
      />

      <Switch
        edge="end"
        size="small"
        checked={checked}
        disabled={disabled}
        onChange={handleToggle}
        sx={{
          "& .MuiSwitch-switchBase.Mui-checked": {
            color: COLORS.orange.base,
            "&:hover": { backgroundColor: `${COLORS.orange.base}14` },
          },
          "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
            backgroundColor: COLORS.orange.base,
          },
        }}
      />
    </ListItem>
  );
};

export const TaskSwitch = memo(TaskSwitchComponent);
